export default "__VITE_ASSET__CvEO6LjM__"